"use client";

import { RuntimeErrorFallback } from "@/components/flowbite/error-page/runtime-error-fallback";

export default function RuntimeError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <RuntimeErrorFallback onRetry={reset} />;
}
